import { PaletteMode } from '@mui/material';
import createTheme from '@mui/material/styles/createTheme';
import { themeConstants } from './themeConstants';

declare module '@mui/material/styles' {
  interface Components {
    MuiLoadingButton: Components['MuiButton'];
  }
}

const theme = (paletteType: PaletteMode) =>
  createTheme({
    palette: {
      mode: paletteType,
      primary: {
        main: themeConstants.primary.main,
        light: themeConstants.primary.light,
        dark: themeConstants.primary.dark,
        contrastText: themeConstants.primary.contrastText,
      },
      secondary: {
        main: themeConstants.secondary.main,
        light: themeConstants.secondary.light,
        dark: themeConstants.secondary.dark,
        contrastText: themeConstants.secondary.contrastText,
      },
      background: {
        default: paletteType === 'light' ? '#eaeaea' : '#121212',
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: 'white',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            background: themeConstants.primary.gradient,
            color: themeConstants.primary.contrastText,
            '&:hover': {
              background: themeConstants.primary.gradient,
              filter: 'brightness(0.9)',
            },
          },
          containedSecondary: {
            background: themeConstants.secondary.gradient,
            color: themeConstants.secondary.contrastText,
            '&:hover': {
              background: themeConstants.secondary.gradient,
              filter: 'brightness(0.9)',
            },
          },
        },
      },
      MuiLoadingButton: {
        styleOverrides: {
          containedPrimary: {
            background: themeConstants.primary.gradient,
            color: themeConstants.primary.contrastText,
            '&:hover': {
              background: themeConstants.primary.gradient,
              filter: 'brightness(0.9)',
            },
            '&.Mui-disabled': {
              background: 'rgba(0, 0, 0, 0.12) !important',
              color: 'rgba(0, 0, 0, 0.26)',
              backgroundImage: 'none !important',
            },
          },
          containedSecondary: {
            background: themeConstants.secondary.gradient,
            color: themeConstants.secondary.contrastText,
            '&:hover': {
              background: themeConstants.secondary.gradient,
              filter: 'brightness(0.9)',
            },
            '&.Mui-disabled': {
              background: 'rgba(0, 0, 0, 0.12) !important',
              color: 'rgba(0, 0, 0, 0.26)',
              backgroundImage: 'none !important',
            },
          },
        },
      },
    },
  });

export default theme;
